module.exports = __webpack_public_path__ + "img/MSENG1_Cover.bf75ebee.jpg";